require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/menuModule.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/menuModule.legacy.js
// module id = 732
// module chunks = 31